import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {PlanItemModel, ResponseModel} from '@/libs/Api';
import {BusinessModule} from '@/libs/core/models/business-module';
import { PlanItemsDataService } from '../unanswered-data-service';

export const unansweredStore = registerCrudStore<PlanItemModel, PlanItemModel>(BusinessModule.Unanswered, new PlanItemsDataService());
